import * as types from '../../actions/actionTypes';

const defaultState = {
  data: []
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {

    case types.FETCH_LIST_SALE_CAMPAIGN_SUCCESS:
      return { ...state, data: action.data };
    default:
      return nextState;
  }
};
